import React from 'react';

export const illustratorFontSizes = [
  8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72,
];

export const demoProjects = ['VEv7GDcIidgTXTFI1bFu'];

export const pageLoadingErrorMessage =
  "Sorry, this page couldn't be loaded. Please try again or contact us.";

export const onboarding = (isShare) => ({
  web: [
    {
      title: 'Comment mode',
      excerpt:
        'Click on elements to post comment and give contextual feedback to your team.',
    },
    {
      title: 'Edit mode',
      excerpt:
        'Inspect and edit page elements, including font, alignment, spacing, etc.',
    },
    {
      title: isShare ? 'Comments panel' : 'Activity panel',
      excerpt: `All your comments${
        isShare ? '' : ' and edits'
      } will be available here.`,
    },
    {
      title: 'Versions',
      excerpt: [
        'Check and review all the versions of your webpage, image or PDF here.',
        'Review, rename or delete all the versions of your webpage, image or PDF here.',
      ],
    },
    {
      title: 'Pages',
      excerpt:
        'Check all the available webpages, images or PDFs inside this project here.',
    },
    {
      excerpt: 'Save your changes once you are done with all the edits.',
    },
  ],
});

export const fontWeights = [
  {
    value: '100',
    label: 'Thin',
  },
  {
    value: '100i',
    label: 'Thin Italics',
  },
  {
    value: '200',
    label: 'Extra Light',
  },
  {
    value: '200i',
    label: 'Extra Light Italics',
  },
  {
    value: '300',
    label: 'Light',
  },
  {
    value: '300i',
    label: 'Light Italics',
  },
  {
    value: '400',
    label: 'Regular',
  },
  {
    value: '400i',
    label: 'Regular Italics',
  },
  {
    value: '500',
    label: 'Medium',
  },
  {
    value: '500i',
    label: 'Medium Italics',
  },
  {
    value: '600',
    label: 'Semi Bold',
  },
  {
    value: '600i',
    label: 'Semi Bold Italics',
  },
  {
    value: '700',
    label: 'Bold',
  },
  {
    value: '700i',
    label: 'Bold Italics',
  },
  {
    value: '800',
    label: 'Extra Bold',
  },
  {
    value: '800i',
    label: 'Extra Bold Italics',
  },
  {
    value: '900',
    label: 'Black',
  },
  {
    value: '900i',
    label: 'Black Italics',
  },
];

export const borderStyles = [
  {
    value: 'none',
    label: 'None',
  },
  {
    value: 'dotted',
    label: 'Dotted',
  },
  {
    value: 'dashed',
    label: 'Dashed',
  },
  {
    value: 'solid',
    label: 'Solid',
  },
  {
    value: 'double',
    label: 'Double',
  },
  {
    value: 'groove',
    label: 'Groove',
  },
  {
    value: 'ridge',
    label: 'Ridge',
  },
  {
    value: 'inset',
    label: 'Inset',
  },
  {
    value: 'outset',
    label: 'Outset',
  },
];

export const upgradePlans = [
  {
    id: 'standard',
    name: 'Standard',
    description: 'Manage web projects for clients',
    monthly: 15,
    yearly: 150,
    features: [
      {
        id: 0,
        content: '1 editor (additional at $4/month)',
      },
      {
        id: 1,
        content: (
          <>
            <strong>2</strong>
            &nbsp;projects
          </>
        ),
      },
      {
        id: 2,
        content: (
          <>
            <strong>Unlimited</strong>
            &nbsp;pages
          </>
        ),
      },
      {
        id: 3,
        content: (
          <>
            <strong>Unlimited</strong>
            &nbsp;collaborators
          </>
        ),
      },
      {
        id: 4,
        content: 'Guest commenting',
      },
      {
        id: 5,
        content: 'Video commenting',
      },
      {
        id: 6,
        content: 'Slack & Trello integrations',
      },
    ],
  },
  {
    id: 'pro',
    name: 'Pro',
    description: 'Collaborate feedback in small team',
    monthly: 40,
    yearly: 400,
    features: [
      {
        id: 0,
        content: '5 editors (additional at $4/month)',
      },
      {
        id: 1,
        content: (
          <>
            <strong>Unlimited</strong>
            &nbsp;projects
          </>
        ),
      },
      {
        id: 2,
        content: (
          <>
            <strong>Unlimited</strong>
            &nbsp;collaborators
          </>
        ),
      },
      {
        id: 3,
        content: 'Guest commenting',
      },
      {
        id: 4,
        content: 'Video commenting',
      },
      {
        id: 5,
        content: 'All current & upcoming integrations',
      },
      {
        id: 6,
        content: <strong>Web app support</strong>,
      },
    ],
  },
  {
    id: 'team',
    name: 'Team',
    description: 'Create and add your team members so they can manage projects',
    monthly: 240,
    yearly: 2400,
    features: [
      {
        id: 0,
        content: (
          <>
            <strong>Unlimited</strong>
            &nbsp;projects, pages, editors &amp; collaborators
          </>
        ),
      },
      {
        id: 1,
        content: 'Multiple team members',
      },
      {
        id: 2,
        content: 'Guest commenting',
      },
      {
        id: 3,
        content: 'Video commenting',
      },
      {
        id: 4,
        content: 'All current & upcoming integrations',
      },
      {
        id: 5,
        content: <strong>Relationship manager</strong>,
      },
      {
        id: 6,
        content: <strong>Custom domain &amp; branding</strong>,
      },
      {
        id: 7,
        content: <strong>Web app support</strong>,
      },
    ],
  },
];

export const appsSumoTiers = [
  {
    id: 'ruttl_tier1',
    title: 'Tier 1',
    amount: 49,
    projects: 10,
    users: 1,
    features: [
      '10 projects',
      'Unlimited pages',
      'Unlimited collaborators',
      'Edit mode',
      'Comment mode',
      '1 team member/user team',
    ],
  },
  {
    id: 'ruttl_tier2',
    title: 'Tier 2',
    amount: 109,
    projects: -1,
    users: 5,
    features: [
      'Unlimited projects',
      'Unlimited pages',
      'Unlimited collaborators',
      'Edit mode',
      'Comment mode',
      '5 team members/user team',
    ],
  },
  {
    id: 'ruttl_tier3',
    title: 'Tier 3',
    amount: 179,
    projects: -1,
    users: -1,
    features: [
      'Unlimited projects',
      'Unlimited pages',
      'Unlimited collaborators',
      'Edit mode',
      'Comment mode',
      'Unlimited team member/user team',
      'Custom branding',
    ],
  },
];

export const sortingOptions = [
  {
    id: 'modifiedAt',
    label: 'Last updated',
  },
  {
    id: 'createdAt',
    label: 'By date added',
  },
  {
    id: 'title',
    label: 'By name',
  },
  {
    id: 'sortOrder',
    label: 'By sort order',
  },
];

export const defaultEmailPreferences = {
  comments: true,
  mentions: true,
  commentResolve: true,
  edits: true,
  pagesApproved: true,
  pagesUnapproved: true,
  marketing: true,
  blogUpdatesBugFixes: true,
};

export const browserExtension = {
  chromeLink:
    'https://chrome.google.com/webstore/detail/ruttl/doecfodblgfnjmmphbedjgllipnbgbld',
  chromeID: 'doecfodblgfnjmmphbedjgllipnbgbld',
};
